/*
* Association current order redirect view for authenticated users
*/

import * as React from 'react';
import * as _ from 'lodash';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { connectRequest } from 'redux-query';
import { push } from 'react-router-redux';
import { withRouter } from 'react-router-dom';

import * as AppComp from '../common/app-component-base';
import { Formatters } from '../common/formatters';
import * as ReduxQueries from '../queries';
import ApiEndpoints from '../config/apiendpoints';
import { NavigationLinks } from '../common/navigation';

export interface IAssociationViewOrderProps extends AppComp.IAppComponentProps {
    association: any;
    associationId: any;
    currentOrderId: any;
    navigateTo?: any;
}

class AssociationViewOrder extends AppComp.AppComponent<IAssociationViewOrderProps, any> {
    public constructor(props: any) {
        super(props, 'app.association-detail.');        
    }

    public componentDidUpdate() {
        const { currentOrderId, association, associationId } =  this.props;                

        if (association && (Formatters.getInt(association, 'associationId') === Number(associationId))) {            
            if (currentOrderId > 0) {
                // console.log(`AssociationViewOrder componentDidUpdate REDIRECT ORDER currentOrderId ${currentOrderId}`);
                this.props.navigateTo(NavigationLinks.orderDetail(currentOrderId));
            } else {
                // console.log(`AssociationViewOrder componentDidUpdate REDIRECT ASSOC ${associationId}`);            
                this.props.navigateTo(NavigationLinks.associationDetail(associationId));
            }
        }        
    }

    // Handlers
    // public handleViewOrderButton(e: any, orderId: any) {        
    //     this.props.navigateTo(NavigationLinks.orderDetail(orderId));
    // }

    // public handleViewAssociationButton(e: any, associationId: any) {        
    //     this.props.navigateTo(NavigationLinks.associationDetail(associationId));
    // }

    public render() {           
        return (<div />);
    }
}

const getApiUrl = props => ApiEndpoints.getAssociationDetailUrl(props.match.params.associationId);

const mapPropsToConfigs = (props) => {
    return [
        ReduxQueries.Queries.getAssociationDetailRequest(
            getApiUrl(props),
            ReduxQueries.PropsAccessToken(props),
        )        
    ];
};

const mapStateToProps = (state, props) => {
    return ReduxQueries.MapQueryStateToPropsByUrl(getApiUrl(props), state, props, {
        associationId: props.match.params.associationId,
        association: state.entities.associationDetailAssociation,
        currentOrderId: state.entities.associationDetailAssociationCurrentOrderId,
    });
};

const mapDispatchToProps = {
    navigateTo: (path) => push(path)
};

const AssociationViewOrderContainer = compose<any>(
    connect(mapStateToProps, mapDispatchToProps),
    connectRequest(mapPropsToConfigs)
  )(AssociationViewOrder);

export default withRouter(AssociationViewOrderContainer);



// WEBPACK FOOTER //
// ./src/association/view-order.tsx